<template>
  <div class="public-content order">
    <div class="breadcrumb">关联业务</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-input v-model="formInline.fullName" placeholder="请输入业务姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号:">
              <el-input v-model="formInline.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
                start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" class="fn-right form-btn">
            <div v-show="ifAddPlateform" style="line-height:30px;float: right;margin-right: 20px;">当前业务主管：{{ $route.query.fullName }}</div>
            <el-button class="search-ok" @click="onSubmit" round>查询</el-button>
            <el-button class="search-ok" @click="cancelRelate" v-show="$hasPermission('crm:admin:salesman:editRelation') && !ifAddPlateform" round>取消关联</el-button>
            <el-button class="search-ok" @click="addPlateform" v-show="$hasPermission('crm:admin:salesman:editRelation') && !ifAddPlateform" round type="primary"> 关联业务</el-button>
            <el-button class="search-ok" @click="cancelRelate" v-show="$hasPermission('crm:admin:salesman:editRelation') && ifAddPlateform" round type="primary">关联 </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" row-key="id">
          <el-table-column type="selection" reserve-selection width="55"></el-table-column>
          <el-table-column label="业务" min-width="10px">
            <template v-slot="scope">
              <span>{{ scope.row.fullName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="10px"></el-table-column>
          <el-table-column prop="salesmanManagerName" label="业务主管" min-width="10px" v-if="ifAddPlateform"></el-table-column>
          <el-table-column prop="registerTime" label="创建日期" min-width="10"></el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" v-if="queryInfo.total !== ''" @changePage="changePage"></v-pagination>
    </div>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { editSalesmanManagerRelation, getSalesListBySalesmanManagerId, getSalesmanList } from '@/api/crm'
export default {
  name: 'order',
  components: {
    VPagination
  },
  inject: ['reload'],
  data () {
    return {
      ifAddPlateform: false,
      queryInfo: {
        type: 3,
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      formInline: {
        fullName: '',
        registerTimeBegin: '',
        registerTimeEnd: '',
        phone: ''
      },
      tableData: [],
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      selected: []
    }
  },
  created () {
    this.onSubmit()
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        console.log(val)
        if (val) {
          this.formInline.registerTimeBegin = val[0]
          this.formInline.registerTimeEnd = val[1]
        } else {
          this.formInline.registerTimeBegin = ''
          this.formInline.registerTimeEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onSubmit () {
      // 已经关联列表
      if (!this.ifAddPlateform) {
        this.getSalesman()
      } else {
        // 未关联列表
        this.getSalesmanNo()
      }
    },
    // 已关联
    getSalesman () {
      getSalesListBySalesmanManagerId({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, salesmanVo: { ...this.formInline, salesmanManagerId: this.$route.query.id } }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.records.map(a => {
            if (a.phone) {
              a.phone = this.$msg.filterBridal(a.phone)
            }
            return a
          })
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    // 未关联
    getSalesmanNo () {
      getSalesmanList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, salesmanVo: this.formInline }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.records.map(a => {
            if (a.phone) {
              a.phone = this.$msg.filterBridal(a.phone)
            }
            return a
          })
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    // 关联/取消关联
    cancelRelate () {
      if (this.selected.length === 0) {
        this.$message.error('未选择业务')
        return
      }
      editSalesmanManagerRelation({ salesmanManagerId: this.$route.query.id, salesmanIds: this.selected, status: this.ifAddPlateform ? '1' : '0' }).then(res => {
        if (res.data.success) {
          this.$message.success(this.ifAddPlateform ? '关联成功' : '已取消关联')
          this.$router.go(-1)
          this.onSubmit()
        }
      })
    },
    addPlateform () {
      this.ifAddPlateform = true
      this.queryInfo.pageNum = 1
      this.onSubmit()
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    },
    handleSelectionChange (val) {
      this.selected = []
      val.forEach(item => {
        this.selected.push(item.id)
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";

.el-date-width {
  /deep/ .el-form-item__content {
    //  width: 50% !important;
    //  display: flex;
  }
}
</style>
